import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { SendOrderStatusAnalyticDataEvent, SendOrderStatusAnalyticPageEvent } from '../../store/order-status-analytics.actions';
import { SetStepOrderStatus } from '../../store/order-status.actions';
import { selectOrderStatusStep } from '../../store/order-status.selectors';

import { OrderStatusStep } from '@api/order/order.models';

@Component({
    selector: 'order-status-layout',
    templateUrl: './order-status-layout.component.html',
    styleUrls: ['./order-status-layout.component.scss'],
})
export class OrderStatusLayoutComponent {
    public step$ = this.store.select(selectOrderStatusStep);

    public OrderStatusStep = OrderStatusStep;

    constructor(
        private readonly store: Store,
    ) {
        this.store.dispatch(SendOrderStatusAnalyticPageEvent({ actionType: 'localizar_pedido' }));
    }

    public goCheck() {
        this.store.dispatch(SendOrderStatusAnalyticDataEvent({ actionType: 'volver_atras' }));
        this.store.dispatch(SetStepOrderStatus({ step: OrderStatusStep.CHECK }));
    }
}
